import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function ConfirmChangeCouncilor({
  handleFormSave,
  caseData,
  loading,
  open,
  setOpen,
}) {
  // Set the modal content based on the caseData
  let title, message;
  if (caseData === 1) {
    title = "This ward already has a councillor";
    message =
      "Approval of your request would result in another councillor being assigned to this ward instead.";
  } else if (caseData === 2) {
    title = "This councillor is already assigned to another ward";
    message =
      "Approval of your request would result in them being assigned to this ward instead, if approved.";
  } else if (caseData === 3) {
    title =
      "This ward already has an active councillor, and this councillor is already assigned to a ward.";
    message =
      "Approval of this change would result in both assignments being updated.";
  }

  const handleForm = () => {
    handleFormSave(true); // This triggers the API call from the parent
  };

  return (
    <ModalComp
      title={title}
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={loading}
          handleSecondaryBtn={handleForm}
          secondaryBtnvariant="primary"
          secondaryBtnText="Submit request"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      {message}
    </ModalComp>
  );
}

export default ConfirmChangeCouncilor;
